/**
 * Rwandan franc.
 */
export var RWF = {
  code: 'RWF',
  base: 10,
  exponent: 0
};